import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_miscarriage: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_miscarriage) {
        info.user_miscarriage.filter((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }
    },
    addData: (state, info) => {
      info.user_miscarriage.editableFlag = true
      state.data.user_miscarriage.push(info.user_miscarriage)
    },
    updateData: (state, info) => {
      return state.data.user_miscarriage = state.data.user_miscarriage.map((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_miscarriage = state.data.user_miscarriage.map((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit, rootState}) {
      const response = await axios.get('admin/users/data/'+rootState.user.currentUser)
      commit ('fetchData', response.data.user_data)
    },
    async updateData ({commit}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('admin/user/data/miscarriage/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit, rootState}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      data.user_id = rootState.user.currentUser
      const response = await axios.post('admin/user/data/miscarriage', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('admin/user/data/miscarriage/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
